<page-header titleText="Prospects">
    <lsq-button
        [style.marginTop]="'1rem'"
        [style.display]="'block'"
        (buttonClick)="handleInitializeProspectClick()"
    >
        Create Prospect
    </lsq-button>
</page-header>
<div class="container-fluid page-container">
    <card>
        <div right-header-content class="prospects-filters">
            <form class="prospects-filters" [formGroup]="filtersFormGroup">
                <div class="invited-by-filter">
                    <lsq-select
                        *ngIf="!filterOptionsInvitedByDisable"
                        [disabled]="filterOptionsInvitedByDisable"
                        [name]="'invited-by-select'"
                        [options]="filterOptionsInvitedBy"
                        [group]="filtersFormGroup"
                        formControlName="invitedByFilter"
                        (ngModelChange)="handleFilterChange()"
                    >
                    </lsq-select>
                </div>
                <div class="prospect-types-filter">
                    <lsq-select
                        *ngIf="filterOptionsProspectTypes"
                        [name]="'prospect-type-select'"
                        [options]="filterOptionsProspectTypes"
                        [group]="filtersFormGroup"
                        formControlName="prospectTypesFilter"
                        (ngModelChange)="handleFilterChange()"
                    >
                    </lsq-select>
                </div>
                <div class="prospect-status-filter">
                    <lsq-select
                        *ngIf="filterOptionsStatus"
                        [name]="'prospect-status-select'"
                        [options]="filterOptionsStatus"
                        [group]="filtersFormGroup"
                        formControlName="prospectStatusFilter"
                        (ngModelChange)="handleFilterChange()"
                    >
                    </lsq-select>
                </div>
                <div class="prospect-name-filter">
                    <lsq-input
                        i18n-placeholder
                        placeholder="Search Prospects"
                        formControlName="prospectName"
                        [name]="'prospectName'"
                        [prependIcon]="[icons.FaMagnifyingGlassSolid, color.GraphicGray]"
                        [group]="filtersFormGroup"
                        (ngModelChange)="handleFilterChange()"
                    >
                    </lsq-input>
                </div>
            </form>
        </div>
        <div card-body>
            <lsq-data-table
                *ngIf="!!tableDataSource"
                [hasHeader]="true"
                [isPaginated]="true"
                [layoutFixed]="true"
                [dataSource]="tableDataSource"
                [skip]="tableDataSource.skip"
                [take]="tableDataSource.take"
            >
                <lsq-column
                    [column]="{
                        header: 'Business Name',
                        key: 'businessName',
                        width: '30%',
                        sortable: true
                    }"
                >
                    <ng-template [custom-cell] let-row="row">
                        <a class="light-font" [routerLink]="getProspectLink(row.id)">
                            <lsq-smart-truncate [value]="row.businessName"></lsq-smart-truncate>
                        </a>
                    </ng-template>
                </lsq-column>
                <lsq-column
                    [column]="{
                        header: 'Prospect Type',
                        key: 'schemaType',
                        width: '20%',
                        sortable: true
                    }"
                >
                    <ng-template [custom-cell] let-row="row">
                        <lsq-smart-truncate
                            [value]="changeProspectType(row.schemaType)"
                        ></lsq-smart-truncate>
                    </ng-template>
                </lsq-column>
                <lsq-column
                    [column]="{
                        header: 'Invited By',
                        key: 'coordinatorUserId',
                        width: '20%',
                        sortable: true
                    }"
                >
                    <ng-template [custom-cell] let-row="row">
                        <lsq-smart-truncate [value]="row.coordinatorUserId"></lsq-smart-truncate>
                    </ng-template>
                </lsq-column>
                <lsq-column
                    [column]="{
                        header: 'Status',
                        key: 'status',
                        width: '15%',
                        sortable: true
                    }"
                >
                </lsq-column>
                <lsq-column
                    [column]="{
                        header: 'Date Created',
                        key: 'createdDate',
                        width: '20%',
                        sortable: true
                    }"
                >
                    <ng-template [custom-cell] let-row="row">
                        <span class="light-font">
                            <lsq-smart-truncate
                                [value]="this.parseDate(row.createdDate)"
                                [popoverValue]="row.createdDate"
                            ></lsq-smart-truncate>
                        </span>
                    </ng-template>
                </lsq-column>
                <lsq-column
                    [column]="{
                        header: 'Latest Activity',
                        key: 'updatedDate',
                        width: '20%',
                        sortable: true
                    }"
                >
                    <ng-template [custom-cell] let-row="row">
                        <span class="light-font">
                            <lsq-smart-truncate
                                [value]="this.parseDate(row.updatedDate)"
                                [popoverValue]="row.updatedDate"
                            ></lsq-smart-truncate>
                        </span>
                    </ng-template>
                </lsq-column>
            </lsq-data-table>
        </div>
    </card>
</div>
